<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Active shares</h1>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Workspace</th>
                        <th scope="col">Portfolio</th>
                        <th scope="col">Data</th>
                        <th scope="col">Shared&nbsp;by</th>
                        <th scope="col">Shared&nbsp;with</th>
                        <th scope="col">Shared&nbsp;at</th>
                        <th scope="col">Shared&nbsp;for</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(s, i) in shares" :key="s.Id">
                        <th scope="row">{{i+1}}</th>
                        <td>{{s.Workspace}}</td>
                        <td>{{s.Portfolio}}</td>
                        <td>
                            <a href="">{{s.Data}}</a>
                        </td>
                        <td>{{s.SharedBy}}</td>
                        <td>{{s.SharedWith}}</td>
                        <td>{{s.SharedAt}}</td>
                        <td>{{s.SharedFor}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { ref } from 'vue'
    import { useOrganizationUnitId } from '@common/composables'

    document.title = 'Shares'

    const tid = useOrganizationUnitId()

    const shares = [
        {
            Id: '311901D5-762C-4B5A-BCC1-C822C010780F',
            Workspace: 'Default',
            Portfolio: 'Mega Portfolio',
            Data: 'Final Report',
            SharedBy: 'janusz@transparentchoice.com',
            SharedWith: 'dan@transparentchoice.com, stuart@transparentchoice.com',
            SharedAt: '2023-10-15',
            SharedFor: '7 days',
        },
        {
            Id: '311901D5-762C-4B5A-BAC1-C822C010780F',
            Workspace: 'Default',
            Portfolio: 'Mega Portfolio',
            Data: 'Request Page',
            SharedBy: 'janusz@transparentchoice.com',
            SharedWith: 'dawid@transparentchoice.com, saulo@transparentchoice.com',
            SharedAt: '2023-10-15',
            SharedFor: '90 days',
        },
    ]
</script>
